/**
 * @param {import('@/plugins/vue-gate/GateKeeper.js').default} gateKeeper
 * @param {string|number} courseId
 */
export async function canAccessActivityRoute(gateKeeper, courseId) {
    if (await gateKeeper.userHasAccessToCourse(courseId)) {
        return true;
    }

    return gateKeeper.userHasGroupPermissionWithinCourse(courseId, 'view a remediation activity');
}
